import {
  createHolidaysResourceGuard,
  deleteHolidaysGuard,
  holidaysCollectionGuard,
  holidaysResourceGuard,
  updateHolidaysResourceGuard,
} from './_api/holidays';

export const resourceGuard = holidaysResourceGuard;
export const addFranchise = createHolidaysResourceGuard;
export const editFranchise = updateHolidaysResourceGuard;
export const deleteFranchise = deleteHolidaysGuard;

export const routeGuard = holidaysCollectionGuard;
